var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonIpThrottling = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M4 31.104V10.58c0-1.89 1.509-3.422 3.37-3.422h26.944c1.861 0 3.37 1.532 3.37 3.422v20.524c0 1.89-1.508 3.422-3.37 3.422H7.37C5.51 34.526 4 32.994 4 31.104z", fill: fills.light }),
        React.createElement("path", { d: "M8.184 11.392a.849.849 0 100-1.698.849.849 0 000 1.698zM10.917 11.391a.849.849 0 100-1.697.849.849 0 000 1.697zM13.647 11.391a.849.849 0 100-1.697.849.849 0 000 1.697zM25.053 34.526s3.445-6.315 9.473-6.315c6.029 0 9.474 6.316 9.474 6.316s-3.445 6.315-9.474 6.315c-6.028 0-9.473-6.316-9.473-6.316z", fill: fills.dark }),
        React.createElement("path", { d: "M34.526 36.895c1.342 0 2.43-1.06 2.43-2.369 0-1.308-1.088-2.368-2.43-2.368s-2.43 1.06-2.43 2.368c0 1.308 1.088 2.369 2.43 2.369z", fill: "#fff" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.87 21.035c-1.652 0-3.252.58-4.522 1.637a.828.828 0 01-1.06-1.273 8.722 8.722 0 0111.165 0 .828.828 0 11-1.06 1.273 7.067 7.067 0 00-4.523-1.637z", fill: fills.dark }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.842 17.448c-2.594 0-5.1.946-7.045 2.661a.828.828 0 01-1.096-1.242 12.311 12.311 0 0116.282 0 .828.828 0 01-1.096 1.242 10.655 10.655 0 00-7.045-2.662zM20.845 24.623c-.721 0-1.425.225-2.014.643a.828.828 0 11-.96-1.35 5.134 5.134 0 015.948 0 .828.828 0 11-.96 1.35 3.478 3.478 0 00-2.014-.643zM20.014 27.383c0-.458.37-.829.828-.829h.006a.828.828 0 010 1.657h-.006a.828.828 0 01-.828-.828z", fill: fills.dark })));
}, {
    name: identiconComponentName,
})({});
